export default __webpack_public_path__ + "static/media/EnquireNowDiscount.6a87aad0.svg";